module.exports = __webpack_public_path__ + "img/curtains.d0470974.jpg";